import { Music } from "lucide-react";

export const AboutSection = () => {
  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32 tracing-border">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Image */}
          <div className="relative">
            <div className="relative aspect-[3/4] overflow-hidden border border-white/5">
              <img
                src="/images/show-liveset.jpg"
                alt="Alchemist (CA)"
                className="absolute inset-0 w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/60 via-transparent to-transparent" />
            </div>
            {/* Floating accent */}
            <div className="absolute -bottom-4 -right-4 w-24 h-24 border border-white/5" />
          </div>

          {/* Bio Content */}
          <div>
            <p className="font-sub text-[10px] text-white/30 tracking-[0.3em] mb-4">ABOUT</p>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tighter mb-8">THE ARTIST</h2>
            <div className="gold-line mb-10" />

            <div className="space-y-6">
              <p className="font-body text-white/60 text-sm md:text-base leading-relaxed">
                Alchemist is a producer and DJ based in Toronto, drawing from influences across
                Deep House, Melodic House and Techno. Blending modern electronic production with
                Indian instruments and melodic elements, his sound focuses on atmosphere,
                emotion, and groove.
              </p>

              <p className="font-body text-white/60 text-sm md:text-base leading-relaxed">
                He has earned support within the electronic community and placements on several
                charts, including a <span className="text-white font-medium">Top-2 Trance Hype release</span> and
                a <span className="text-white font-medium">Top-12 Melodic House & Techno Hype position</span> on Beatport.
              </p>

              <p className="font-body text-white/60 text-sm md:text-base leading-relaxed">
                As a DJ, Alchemist has had the opportunity to play both opening and closing sets
                alongside artists like <span className="text-white/80">Eelke Kleijn, Fideles, Rebuke, Cassian,
                Stephan Bodzin, Simon Doty, Amy Wiles,</span> and <span className="text-white/80">Enamour</span> at venues
                including History, Coda, Story, and select warehouse events in Toronto.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mt-12 pt-8 border-t border-white/10">
              <div>
                <p className="font-heading text-2xl md:text-3xl tracking-tighter text-white">TOP 2</p>
                <p className="font-sub text-[9px] text-white/30 tracking-widest mt-1">TRANCE HYPE<br />BEATPORT</p>
              </div>
              <div>
                <p className="font-heading text-2xl md:text-3xl tracking-tighter text-white">TOP 12</p>
                <p className="font-sub text-[9px] text-white/30 tracking-widest mt-1">MELODIC H&T<br />BEATPORT HYPE</p>
              </div>
              <div>
                <p className="font-heading text-2xl md:text-3xl tracking-tighter text-white">6+</p>
                <p className="font-sub text-[9px] text-white/30 tracking-widest mt-1">NOTABLE<br />SUPPORT SETS</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
